<!--
 * @Author: TinaHuang0183 
 * @Date: 2022-07-18 14:16:55
 * @LastEditors: Tina Huang
 * @LastEditTime: 2023-02-06 21:01:37
 * @FilePath: /notion-widgets-site/src/components/Others.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="container wrapper">
    <el-row :gutter="20" v-for="(row, index) in list" :key="'row-' + index">
      <el-col :span="8" v-for="item in row" :key="item.id">
        <el-card
          class="item-card"
          shadow="hover"
          style="margin-bottom: 10px"
          @click="handleSettingModal(item)"
        >
          <img :src="item.cover" alt="" class="image" />
          <div class="bottom clearfix">
            <h3>{{ item.tag }}<el-tag type="danger" v-if="item.tags" size="mini">{{item.tags}}</el-tag></h3>
            <span class="datetime-tag">{{ item.timestamp | relative }}</span>
            <el-button
              type="primary"
              icon="el-icon-edit"
              round
              class="edit-btn"
              :disabled="item | formatItemBtnDisable"
              @click="handleCreate(item.id)"
              >{{item | formatItemBtn}}</el-button
            >
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      times: [],
      show_setting_modal: false,
      currentItem: null,
      currentComponent: "today",
      show_preview: false,
      list: {},
    };
  },
  mounted() {
    this.getDatas();
  },
  methods: {
    getDatas() {
      const _this = this;
      this.$axios.get(`./others.json?v=${Math.random()}`).then((res) => {
        let times = res.data.list.filter(item => !item.hide);
        _this.times = times;
        let list = {},
          len = times.length;
        for (let i = 0; i < len; i++) {
          let _row = Math.floor(i / 3);
          if (list[_row]) {
            list[_row].push(times[i]);
          } else {
            list[_row] = [times[i]];
          }
        }
        _this.list = list;
      });
    },
    handleCopy() {
      this.$message({
        message: "复制成功，快去Notion体验一下吧",
        type: "success",
      });
    },
    handleSettingModal(item) {
      this.currentItem = item;
      this.currentComponent = item.link;
      this.show_setting_modal = true;
    },
    handleModalClose() {
      this.currentItem = null;
      this.currentComponent = null;
      this.show_setting_modal = false;
      this.show_preview = false;
    },
    handlePreview(item) {
      this.currentItem = item;
      this.show_preview = true;
    },
    handleCreate(id) {
      splitbee.track("Select widget", {
        type: "others",
        id,
      });
      // window.location.href = `/#/create/${id}/time`;
      // return
      this.$router.replace(`/create/${id}/others`);
    },
  },
};
</script>
<style lang="less" scoped>
.image {
  width: 100%;
  display: block;
  height: 160px;
  object-fit: contain;
}
.el-descriptions__title {
  width: 100%;
}
.preview-cover {
  width: 100%;
}
</style>
